module.exports = __webpack_public_path__ + "static/7-e6fa700ef9ed7af187c5358b27d9148e.jpg";